import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RenewInfoComponent implements OnInit {
    msg: string;
    constructor() {
        this.msg = 'Account validity period has been extended.';
    }
    ngOnInit() {}
}
